import { apiAxios } from "@helpers/lib/axios";
import { API_ENDPOINTS } from "@memorang/constants/urls";
import type { ActiveCodesResponse, ApplyAccessCodeResponse } from "./types";

export const applyAccessCode = async ({
	accessCode,
}: {
	accessCode: string;
}): Promise<ApplyAccessCodeResponse> => {
	const { data } = await apiAxios.post(API_ENDPOINTS.COMMERCE_ACCESS_CODE, {
		accessCode,
	});

	if (!data.data) {
		throw new Error(data.message);
	}
	return data;
};

export const getActiveCodes = async ({
	sku,
	productId,
}: {
	sku?: string;
	productId?: string;
}): Promise<ActiveCodesResponse[]> => {
	const { data } = await apiAxios.get(API_ENDPOINTS.COMMERCE_ACCESS_CODE, {
		params: {
			sku,
			productId,
		},
	});
	return data.data;
};

export const resendAccessCode = async ({
	orderId,
	tenantId,
}: {
	orderId: string;
	tenantId: string;
}): Promise<{ success: boolean; message: string }> => {
	const { data } = await apiAxios.post(
		API_ENDPOINTS.COMMERCE_ACCESS_CODE_RESEND,
		{
			orderId,
			tenantId,
		},
	);

	return data;
};
